<template>
  <div class="my-account">
    <div class="wrapper">
      <div class="header">
        <div class="headerCon">
          <div class="account acea-row row-top row-between">
            <div class="assets">
              <div
                style="
					font-size: 15px;
					color:  white;
				"
              >
                账户余额(积分)
              </div>
              <div class="money">{{ now_money || 0 }}</div>
            </div>
            <!-- <router-link
              :to="'/user/Recharge/'"
              class="recharge font-color-red"
              style="
					margin-left: 222px;
					margin-top: -30px;
				"
              >充值
            </router-link> -->
          </div>
        </div>
      </div>
      <div class="nav acea-row row-middle">
        <router-link class="item" :to="'/user/bill/0'">
          <div class="pictrue"><img src="@assets/images/record1.png" /></div>
          <div>账单记录</div>
        </router-link>
        <router-link class="item" :to="'/user/bill/1'">
          <div class="pictrue"><img src="@assets/images/record2.png" /></div>
          <div>消费记录</div>
        </router-link>
        <!-- <router-link class="item" :to="'/user/bill/2'">
          <div class="pictrue"><img src="@assets/images/record3.png" /></div>
          <div>充值记录</div>
        </router-link> -->
      </div>
      <div class="advert acea-row row-between-wrapper"></div>
    </div>
    <Recommend></Recommend>
  </div>
</template>
<script>
import Recommend from "@components/Recommend";
import { getBalance } from "../../api/user";
export default {
  name: "UserAccount",
  components: {
    Recommend
  },
  props: {},
  data: function() {
    return {
      now_money: 0,
      saving_money: 0,
      guarantee_money: 0,
      commission_money: 0,
      orderStatusSum: 0,
      sumSecurity: 0,
      recharge: 0,
      activity: {
        is_bargin: false,
        is_pink: false,
        is_seckill: false
      }
    };
  },
  // watch: {
  //   $route(n) {
  //     this.getIndex();
  //   }
  // },
  mounted: function() {
    this.getIndex();
  },
  methods: {
    goUserSecurity() {
      this.$yrouter.push("/user/UserSecurity/index");
    },
    getIndex: function() {
      let that = this;
      getBalance().then(
        res => {
          that.now_money = res.data.now_money;
          that.saving_money = res.data.saving_money;
          that.guarantee_money = res.data.guarantee_money;
          that.commission_money = res.data.commission_money;
          that.orderStatusSum = res.data.orderStatusSum;
          that.sumSecurity = res.data.sumSecurity;
          that.recharge = res.data.recharge;
        },
        err => {
          that.$dialog.message(err.msg);
        }
      );
    }
  }
};
</script>
